import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ErrorText from "../error-text";
import LabelBox from "../label-box";

const Checkbox = ({
  id,
  required = false,
  label,
  isError = false,
  errorMessage,
  hideLabel = false,
  onChange,
  defaultValue,
  fieldName,
  showValidationMessage = false,
  infoPlacement,
  info,
  showSettings,
  onChangeSettings,
  defaultSettings,
  showAppliedSettings,
  onClickSettings,
  settingsValue,
  onDelete,
  value,
  className,
  children,
  ...props
}) => {
  
  
  const [isChecked, setIsChecked] = useState(defaultValue || false);
  const [defaultValueSetStatus, setDefaultValueSetStatus] = useState(false)

  const settings = useRef(null)
  // fieldValue is being used in case fieldName is passed
  const fieldValue = useRef(null)

  const isControlled = useMemo(() => value !== undefined, [value])


  useEffect(() => {
    if (!value && !defaultValueSetStatus && typeof defaultValue === 'boolean') {
      setDefaultValueSetStatus(true)
      const defaultFieldValue = {
        [fieldName]: defaultValue
      }

      if (defaultSettings) defaultFieldValue.settings = defaultSettings
      fieldValue.current = defaultFieldValue
    }
  }, [defaultSettings, defaultValue, defaultValueSetStatus, fieldName, value])

  const onClickCheckbox = useCallback(() => {
    const currentValue = isControlled ? value : isChecked;
    const changedValue = !currentValue
    const checkBoxData = { id, label}

    if (!isControlled) {
      setIsChecked(changedValue);
    }
    
    if (fieldName) {
      const argData = { [fieldName]: changedValue }
      if (settings.current) argData.settings = settings.current
      fieldValue.current = argData
      onChange && onChange(argData, checkBoxData);
    } else {
      onChange && onChange(changedValue, checkBoxData);
    }
  }, [isChecked, onChange, fieldName, settings, id, label, isControlled, value]);

  const onChangeLabelSettings = useCallback(settingsData => {
    onChangeSettings && onChangeSettings(settingsData)
    settings.current = settingsData
    onChange && onChange(fieldValue.current ? { ...fieldValue.current, settings: settingsData } : { [fieldName]: null, settings: settingsData })
  }, [onChangeSettings, fieldValue, onChange, fieldName])  

  return (
    <div
      {...props} className={`checkbox ${!isError ? "checkbox-normal" : "checkbox-error"} ${className || ""}`}
    >
      <div className="checkbox-container">
        <div id={id} className="checkbox-main" onClick={onClickCheckbox}>
          { (isControlled ? value : isChecked) && <div className="checkbox-selected"></div>}
        </div>
        {!hideLabel && (children || <LabelBox required={required} label={label} infoPlacement={infoPlacement} info={info} showSettings={showSettings} onChangeSettings={onChangeLabelSettings} defaultSettings={defaultSettings} showAppliedSettings={showAppliedSettings} onClickSettings={onClickSettings} settingsValue={settingsValue} onDelete={onDelete}/>) }
      </div>
      {showValidationMessage && <ErrorText message={errorMessage} />}
    </div>
  );
};

export default Checkbox;
